import React from "react"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { AccountSelector } from "./AccountSelector.jsx"
import { StoreSelector } from "./StoreSelector.jsx"

export const TopMenu = ({
	goBack,
	accountSelector,
	storeSelector,
	storeSelectorDisabled,
	other,
	secondRow,
}) => {
	const navigate = useNavigate()
	const { t } = useTranslation()

	return (
		<div
			style={{
				position: "fixed",
				zIndex: "500",
				width: "100%",
				padding: "1rem 1.5rem",
				display: "flex",
				flexDirection: "column",
				gap: "0.5rem",
			}}
		>
			<div
				style={{
					display: "flex",
					justifyContent: "start",
					gap: "1rem",
					alignItems: "center",
				}}
			>
				{goBack && (
					<div
						onClick={() => navigate(goBack)}
						style={{
							display: "flex",
							alignItems: "center",
							gap: "0.3rem",
							background: "#fff",
							borderRadius: "1rem",
							padding: "0.2rem 0.6rem",
							border: "1px solid #ccc",
							boxShadow:
								"0 1px 1px rgba(0,0,0,0.1), 0 2px 2px rgba(0,0,0,0.1)",
							cursor: "pointer",
						}}
					>
						<svg
							style={{
								width: "1.2rem",
								height: "1.2rem",
								color: "#222",
							}}
							viewBox="0 0 24 24"
						>
							<path
								fill="currentColor"
								d="M12 9.059V6.5a1.001 1.001 0 0 0-1.707-.708L4 12l6.293 6.207a.997.997 0 0 0 1.414 0A.999.999 0 0 0 12 17.5v-2.489c2.75.068 5.755.566 8 3.989v-1c0-4.633-3.5-8.443-8-8.941z"
							></path>
						</svg>
						<span
							style={{
								color: "#333",
								fontSize: "1rem",
								fontWeight: "500",
							}}
						>
							{t("common.go_back")}
						</span>
					</div>
				)}

				{accountSelector && <AccountSelector />}

				{storeSelector && (
					<StoreSelector
						independent={!accountSelector}
						disabled={storeSelectorDisabled || false}
					/>
				)}

				{other ?? null}
			</div>

			{secondRow ?? null}
		</div>
	)
}
